import styled from "@emotion/styled";

// Matches the site's about cards: white base with a soft blue inner glow.
const cardBg = "#f8fafb65";
const cardGlow = "0 25px 48.2px 0 #c2dfece6 inset";
const softGlow = "0 14px 30px 0 #c2dfec99 inset";
const border = "rgba(0,0,0,0.1)";
const muted = "#5f6368";

export const DocsWrapper = styled.div`
  min-height: 100vh;
  background: #fff;
  color: #000;
`;

export const TopBar = styled.header`
  position: sticky;
  top: 0;
  z-index: 20;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid ${border};

  a {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #000;
    text-decoration: none;
  }
  @media (max-width: 599px) {
    padding: 0 16px;
  }
`;

export const Brand = styled.a`
  img {
    height: 22px;
  }
  span {
    font-size: 13px;
    font-family: "primary1" !important;
    line-height: 1;
    border: 1px solid rgba(0, 0, 0, 0.18);
    border-radius: 999px;
    padding: 6px 10px;
  }
`;

export const TopActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const BackLink = styled.a`
  font-size: 14px;
  font-family: "primary1" !important;
  padding: 9px 16px;
  border-radius: 999px;
  background: #000;
  color: #fff !important;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.85;
  }
  @media (max-width: 599px) {
    display: none !important;
  }
`;

export const MenuToggle = styled.button`
  display: none;
  background: #fff;
  border: 1px solid ${border};
  border-radius: 10px;
  color: #000;
  width: 38px;
  height: 38px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  @media (max-width: 999px) {
    display: flex;
  }
`;

export const Layout = styled.div`
  display: flex;
  max-width: 1440px;
  margin: 0 auto;
  gap: 32px;
  padding: 24px;
  @media (max-width: 599px) {
    padding: 16px;
  }
`;

export const Sidebar = styled.aside`
  position: sticky;
  top: 88px;
  flex: 0 0 280px;
  height: calc(100vh - 112px);
  overflow-y: auto;
  padding: 16px 10px;
  border-radius: 8px;
  background: ${cardBg};
  box-shadow: ${cardGlow};

  @media (max-width: 999px) {
    position: fixed;
    top: 64px;
    left: 0;
    bottom: 0;
    height: auto;
    width: 290px;
    z-index: 30;
    border-radius: 0;
    background: #fff;
    box-shadow: ${cardGlow}, 4px 0 24px rgba(0, 0, 0, 0.08);
    transform: translateX(${(p) => (p.open ? "0" : "-100%")});
    transition: transform 0.25s ease;
  }
`;

export const Backdrop = styled.div`
  display: none;
  @media (max-width: 999px) {
    display: ${(p) => (p.open ? "block" : "none")};
    position: fixed;
    inset: 64px 0 0 0;
    z-index: 25;
    background: rgba(0, 0, 0, 0.25);
  }
`;

export const GroupTitle = styled.p`
  margin: 18px 10px 8px;
  font-size: 12px;
  font-family: "primary1" !important;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #000;
  &:first-of-type {
    margin-top: 4px;
  }
`;

export const NavItem = styled.a`
  display: block;
  padding: 8px 12px;
  margin: 2px 0;
  border-radius: 8px;
  font-size: 14.5px;
  line-height: 1.4;
  text-decoration: none;
  cursor: pointer;
  color: ${(p) => (p.active ? "#fff" : "#3c3c3c")};
  background: ${(p) => (p.active ? "#000" : "transparent")};
  font-family: ${(p) => (p.active ? '"primary1" !important' : "inherit")};
  transition: color 0.15s, background 0.15s;
  &:hover {
    color: ${(p) => (p.active ? "#fff" : "#000")};
    background: ${(p) => (p.active ? "#000" : "rgba(255,255,255,0.8)")};
  }
`;

export const Main = styled.main`
  flex: 1;
  min-width: 0;
  max-width: 860px;
`;

export const Hero = styled.div`
  margin-bottom: 36px;
  border-radius: 8px;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const Breadcrumb = styled.span`
  display: inline-block;
  margin: 0 0 14px;
  font-size: 13px;
  line-height: 1;
  font-family: "primary1" !important;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  padding: 7px 10px;
  background: rgba(255, 255, 255, 0.74);
`;

export const PageTitle = styled.h1`
  margin: 0 0 12px;
  font-size: 44px;
  line-height: 1.15;
  font-weight: 400;
  font-family: "primary1" !important;
  color: #000;
  @media (max-width: 599px) {
    font-size: 32px;
  }
`;

export const Subtitle = styled.p`
  margin: 0 0 8px;
  font-size: 18px;
  color: ${muted};
`;

export const Content = styled.article`
  font-size: 17px;
  line-height: 1.7;
  color: #1a1a1a;

  h2 {
    margin: 40px 0 14px;
    font-size: 24px;
    line-height: 1.3;
    font-weight: 400;
    font-family: "primary1" !important;
    color: #000;
    scroll-margin-top: 90px;
  }
  h3 {
    margin: 26px 0 8px;
    font-size: 18px;
    font-weight: 400;
    font-family: "primary1" !important;
    color: #000;
  }
  p {
    margin: 0 0 18px;
  }
  ul {
    margin: 0 0 22px;
    padding-left: 22px;
  }
  li {
    margin-bottom: 8px;
    &::marker {
      color: #000;
    }
  }
`;

export const TableWrap = styled.div`
  margin: 8px 0 26px;
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid ${border};

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
  }
  th {
    text-align: left;
    padding: 12px 16px;
    color: #000;
    font-weight: 400;
    font-family: "primary1" !important;
    background: ${cardBg};
    box-shadow: ${softGlow};
    border-bottom: 1px solid ${border};
  }
  td {
    padding: 12px 16px;
    vertical-align: top;
    border-bottom: 1px solid ${border};
  }
  tr:last-of-type td {
    border-bottom: none;
  }
  td:first-of-type {
    color: #000;
    font-family: "primary1" !important;
    min-width: 140px;
  }
`;

export const StatusPill = styled.span`
  display: inline-block;
  font-size: 12.5px;
  line-height: 1;
  white-space: nowrap;
  font-family: "primary1" !important;
  border-radius: 999px;
  padding: 6px 10px;
  color: ${(p) => (p.available ? "#fff" : "#000")};
  background: ${(p) => (p.available ? "#000" : "rgba(255,255,255,0.74)")};
  border: 1px solid ${(p) => (p.available ? "#000" : "rgba(0,0,0,0.18)")};
`;

export const Note = styled.div`
  margin: 8px 0 26px;
  padding: 18px 22px;
  border-radius: 8px;
  background: ${cardBg};
  box-shadow: ${cardGlow};
  color: #000;
`;

export const Flow = styled.figure`
  margin: 12px 0 30px;

  .steps {
    display: flex;
    align-items: stretch;
  }
  .step {
    flex: 1 1 0;
    min-width: 0;
    padding: 14px 12px;
    border-radius: 8px;
    background: ${cardBg};
    box-shadow: ${softGlow};
    border: 1px solid rgba(0, 0, 0, 0.06);
  }
  .step strong {
    display: block;
    font-size: 13.5px;
    line-height: 1.35;
    font-weight: 400;
    font-family: "primary1" !important;
    color: #000;
    margin-bottom: 4px;
  }
  .step small {
    display: block;
    font-size: 12px;
    line-height: 1.45;
    color: ${muted};
  }
  .arrow {
    flex: 0 0 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    font-size: 14px;
  }
  figcaption {
    margin-top: 12px;
    text-align: center;
    font-size: 13px;
    color: ${muted};
  }

  @media (max-width: 699px) {
    .steps {
      flex-direction: column;
    }
    .arrow {
      flex-basis: 20px;
      transform: rotate(90deg);
    }
  }

  /* Stacked layer diagrams */
  ${(p) =>
    p.vertical &&
    `
    .steps {
      flex-direction: column;
    }
    .step {
      text-align: center;
    }
    .arrow {
      flex-basis: 22px;
      transform: rotate(90deg);
    }
  `}
`;

export const PagerRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin: 48px 0 24px;
  @media (max-width: 599px) {
    grid-template-columns: 1fr;
  }
`;

export const PagerLink = styled.a`
  display: block;
  padding: 18px 20px;
  border-radius: 8px;
  background: ${cardBg};
  box-shadow: ${cardGlow};
  text-decoration: none;
  text-align: ${(p) => (p.next ? "right" : "left")};
  grid-column: ${(p) => (p.next ? "2" : "1")};
  cursor: pointer;
  transition: transform 0.2s;
  small {
    display: block;
    font-size: 12px;
    color: ${muted};
    margin-bottom: 4px;
  }
  span {
    color: #000;
    font-family: "primary1" !important;
  }
  &:hover {
    transform: translateY(-2px);
  }
  @media (max-width: 599px) {
    grid-column: 1;
    text-align: left;
  }
`;

export const Toc = styled.aside`
  position: sticky;
  top: 88px;
  flex: 0 0 220px;
  align-self: flex-start;
  font-size: 13.5px;

  p {
    margin: 4px 0 10px;
    font-size: 12px;
    font-family: "primary1" !important;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #000;
  }
  a {
    display: block;
    padding: 5px 0 5px 12px;
    border-left: 1px solid ${border};
    color: ${muted};
    text-decoration: none;
    line-height: 1.4;
    &:hover {
      color: #000;
      border-color: #000;
    }
  }
  @media (max-width: 1279px) {
    display: none;
  }
`;

export const DocsFooter = styled.p`
  padding-top: 20px;
  border-top: 1px solid ${border};
  font-size: 13px;
  color: ${muted};
`;
